import { Link } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import '../css/banner.scss';

// interface Props {
//   lightId: string;
//   lightName: string;
//   lightComment: string;
// }

// const renderIndicator = (
//   clickHandler: (e: React.MouseEvent | React.KeyboardEvent) => void,
//   isSelected: boolean,
//   index: number,
//   label: string
// ) => React.ReactNode;

const Booking = () => (
  <div>
    <div className="booking">
      <div>
        <Carousel
          infiniteLoop={true}
          showThumbs={false}
          autoPlay={true}
          emulateTouch={true}
          swipeable={true}
          useKeyboardArrows={true}
          showStatus={false}
          interval={2000}
        // renderIndicator={renderIndicator}
        >
          <div id="carousel-1" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/1-jonglerie.jpg" alt="Spectacle de jonglerie" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-2" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/2-mono.jpg" alt="Spectacle de monocycle" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-3" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/3-trapeze.jpg" alt="Spectacle de trapère" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-4" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/4-mono.jpg" alt="Spectacle de monocycle" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-5" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/5-equilibre.jpg" alt="Equilibre" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-6" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/6-jonglerie.jpg" alt="Jonglerie" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-7" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/7-diabolo.jpg" alt="Utilisation du diabolo" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-8" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/8-aerien.jpg" alt="Cours d'aérien" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-9" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/9-aerien.jpg" alt="Cours d'aérien" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-10" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/10-aerien.jpg" alt="Cours d'aérien" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-11" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/11-aerien.jpeg" alt="Spectacle d'aérien" />
                </div>
              </Link>
            </div>
          </div>
        </Carousel>
      </div>
    </div>

  </div>
  //onclick="openScheduling(17983227)"
);

export default Booking;
